import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import {BiArrowBack} from "react-icons/bi";
import {Link, useParams} from "react-router-dom";
import commonHeader from "../../assets/img/commonHeader.png";
import profileImage from "../../assets/img/profileDefaultImg.png";
import reviewComment from "../../assets/img/reviewComment.png";
import defaultImg from "../../assets/img/profileDefaultImg.png";
import DOMPurify from "dompurify";
import {useTranslation} from "react-i18next";
import commomHeader from "../../assets/img/commonHeader.png";
import Linkify from "react-linkify";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";
import "../../css/web/UserReviewRenew.css";

function UserReviewDetailPg() {

    const { t } = useTranslation();
    const [theme] = useTheme();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    const {seqNum} = useParams();

    const [memberInfo, setMemberInfo] = useState("");
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response)=> {
                setMemberInfo(response.data)
            })
            .catch(()=> {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (SSAT || LCAT) {
            findMember();
        }
    }, [SSAT, LCAT])

    const [reviewData, setReviewData] = useState([]);
    const [reviewProfileImg, setReviewProfileImg] = useState(profileImage)
    const [reviewList, setReviewList] = useState([]);
    const [reviewCommentList, setReviewCommentList] = useState([]);

    const selectReviewData = () =>
        axios({
            method: 'get',
            url: '/review/selectReviewData',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                seqNum: seqNum
            }
        })
            .then((response) => {
                setReviewData(response.data);
                const isDefaultImg = response && response.data && response.data.memberDTO && response.data.memberDTO.profileDTO && response.data.memberDTO.profileDTO.filename;
                setReviewProfileImg(
                    isDefaultImg ?
                        "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + response.data.memberDTO.profileDTO.filename
                        :
                        profileImage
                );
                setReviewList(response.data.reviewPhotoDTO)
                setReviewCommentList(response.data.reviewCommentDTO)
            })

    useEffect(() => {
        if (seqNum) {
            selectReviewData();
        }
    }, [seqNum])



    const useSanitizedHTML = ((rawHTML) => {
        if (!rawHTML) return "";
        return DOMPurify.sanitize(rawHTML.replace(/\n/g, '<br>'));
    })
    const sanitizedContent = useSanitizedHTML(reviewData?.content);

    const textareaRef = useRef(null);
    const [reviewCommentText, setReviewCommentText] = useState('');

    const handleCommentTextChange = (e) => {
        setReviewCommentText(e.target.value);
        const textarea = textareaRef.current;
        textarea.style.height = 'auto';
        textarea.style.height = Math.min(textarea.scrollHeight, 200) + 'px';
    };

    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = Math.min(textarea.scrollHeight, 200) + 'px';
        }
    }, [reviewCommentText])

    const saveReviewComment = () =>
        axios({
            method: 'post',
            url: '/review/saveReviewComment',
            /*
             * 코멘트 내용은 URL(params)이 아니라 본문(data)으로 보낸다.
             *  axios 가 URL 을 만들 때 %5B/%5D 를 날것의 대괄호로 되돌리는데,
             *  Tomcat 은 URL 의 대괄호를 잘못된 요청으로 보고 400 을 돌려준다.
             *  그래서 '[부피 큰 제품박스만 제거]' 같은 답변이 등록되지 않았다.
             *  본문으로 보내면 어떤 특수문자가 들어와도 안전하다.
             *  (백엔드 @RequestParam 은 폼 본문도 그대로 읽으므로 서버는 그대로 둔다)
             */
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            data: [
                `reviewSeqNum=${encodeURIComponent(reviewData.seqNum)}`,
                `memberMbNum=${encodeURIComponent(memberInfo.mbNum)}`,
                `content=${encodeURIComponent(reviewCommentText)}`,
            ].join('&'),
        })
            .then((response) => {
                const newComment = response.data;
                const updatedComments = [...reviewCommentList, newComment];
                setReviewCommentList(updatedComments);
                setReviewCommentText('');
            })
            .catch((response) => {
                console.log("코멘트 등록실패")
            })

    const sanitizeHTML = (rawHTML) => {
        if (!rawHTML) return "";
        return DOMPurify.sanitize(rawHTML.replace(/\n/g, '<br>'));
    };

    const formatDate = (dateStr) => {
        if (dateStr?.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    const maskingName = (name) => {
        if (!name) return '';
        const len = name.length;
        // 1. 한 글자일 경우: 그대로 반환
        if (len === 1) {
            return name;
        }
        // 2. 두 글자일 경우: 뒤에만 가림 (예: 김철 -> 김*)
        if (len === 2) {
            return name.substring(0, 1) + '*';
        }
        // 3. 세 글자 이상일 경우: 앞, 뒤 한 글자씩 남기고 가운데 마스킹
        // (예: 홍길동 -> 홍*동, Michael -> M*****l)
        else {
            const firstChar = name.substring(0, 1);
            const lastChar = name.substring(len - 1, len);
            const midMask = '*'.repeat(len - 2); // 가운데 글자 수만큼 * 반복

            return firstChar + midMask + lastChar;
        }
    };

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-head rvd-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" src={commomHeader} alt="header"/>
                    <p className="up-head-title">{t(`rvdtHeader`)}</p>
                </div>
            </div>

            <div className="up-card rv-detail-card">
                {/*작성자 헤더*/}
                <div className="rv-detail-top">
                    <img className="rv-avatar" alt="profileImg" src={reviewProfileImg}/>
                    <div className="rv-detail-who">
                        <p className="rv-detail-name">{maskingName(reviewData?.memberDTO?.userName)}</p>
                        <p className="rv-detail-title">[{reviewData?.country}-{reviewData?.shipco}]<span style={{marginLeft: "5px"}}>{reviewData?.title}</span></p>
                    </div>
                    <Link to={"/UserReviewPg"} className="rv-detail-back">
                        <BiArrowBack/>
                    </Link>
                </div>

                {/*컨텐츠*/}
                <div className="rv-detail-body">
                    <Linkify
                        componentDecorator={(decoratedHref, decoratedText, key) => (
                            <a target="blank" href={decoratedHref} key={key}>
                                {decoratedText}
                            </a>
                        )}
                    >
                        {DOMPurify.sanitize(reviewData?.content)}
                    </Linkify>
                </div>

                {/*이미지: 원본 비율 유지(가로/세로 자연 출력)*/}
                <div className="rv-detail-imgs">
                    {reviewList.map((photo, index) => (
                        <img key={index}
                             src={"https://toeloperfile.s3.ap-northeast-2.amazonaws.com/reviewPhoto/" + photo.fileNm}
                             alt="reviewImg"/>
                    ))}
                </div>

                {/*댓글*/}
                <div>
                    <div className="rv-cmt-head">
                        <img alt="CommentImage" src={reviewComment}/>
                        <p className="t">{t(`rvdtComt`)}</p>
                        <p className="n">{reviewCommentList.length}</p>
                    </div>
                    {reviewCommentList.map((comment, i) => (
                        <div key={i} className="rv-cmt">
                            <div className="rv-cmt-who">
                                <div className="l">
                                    <img src={comment?.memberDTO?.profileDTO?.filename ? "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/"
                                        + comment?.memberDTO?.profileDTO?.filename : defaultImg} alt="reviewImg"/>
                                    <p className="nm">{maskingName(comment?.memberDTO?.userName)}</p>
                                </div>
                                <p className="dt">{formatDate(comment.regDate)}</p>
                            </div>
                            <p className="rv-cmt-body" dangerouslySetInnerHTML={{__html: sanitizeHTML(comment?.content)}}></p>
                        </div>
                    ))}
                    {(LCAT || SSAT) ?
                        <div className="rv-cmt-input">
                            <textarea
                                ref={textareaRef}
                                spellCheck="false"
                                value={reviewCommentText}
                                maxLength={5000}
                                onChange={handleCommentTextChange}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault(); // To prevent the default action of the Enter key
                                        saveReviewComment();
                                    }
                                }}/>
                            <button onClick={saveReviewComment}>{t(`rvdtBt`)}</button>
                        </div>
                        :
                        null
                    }
                </div>
            </div>
        </div>
    )
}

export default UserReviewDetailPg
